__turbopack_context__.v({
  "canvasEmbed": "TemplateDetailPage-module__Lg556W__canvasEmbed",
  "canvasTitleSection": "TemplateDetailPage-module__Lg556W__canvasTitleSection",
  "ctaBanner": "TemplateDetailPage-module__Lg556W__ctaBanner",
  "faqItem": "TemplateDetailPage-module__Lg556W__faqItem",
  "faqItemIcon": "TemplateDetailPage-module__Lg556W__faqItemIcon",
  "faqItemSummary": "TemplateDetailPage-module__Lg556W__faqItemSummary",
  "faqs": "TemplateDetailPage-module__Lg556W__faqs",
  "hiddenOnMobile": "TemplateDetailPage-module__Lg556W__hiddenOnMobile",
  "layout": "TemplateDetailPage-module__Lg556W__layout",
  "mainContent": "TemplateDetailPage-module__Lg556W__mainContent",
  "page": "TemplateDetailPage-module__Lg556W__page",
  "relatedTemplates": "TemplateDetailPage-module__Lg556W__relatedTemplates",
  "sidebar": "TemplateDetailPage-module__Lg556W__sidebar",
  "title": "TemplateDetailPage-module__Lg556W__title",
});
